import React from 'react';
import { Box, Typography } from '@mui/material';
import { InsertDriveFileOutlinedIcon } from 'icons/materialIcons';
import WhiteButtonWithIcon from 'components/common/button/WhiteButtonWithIcon';
import { useNavigate } from 'react-router-dom';

const NeedHelpContainer = () => {
    const navigate = useNavigate();

    const handleViewDocs = () => {
        // Navigate to the introduction blog (assuming the introduction blog has an ID of 1)
        navigate('/blog/0');
    };

    return (
        <Box sx={{
            backgroundColor: '#ffffff',
            borderRadius: '12px'
        }}>
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 600,
                    color: '#242020',
                    p: 3,
                    pb: 0
                }}
            >
                Need Help?
            </Typography>

            <Box sx={{ p: 3 }}>
                <Box
                    sx={{
                        width: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '12px 16px',
                        backgroundColor: 'white',
                        border: '1px solid',
                        borderColor: '#E0E0E0',
                        borderRadius: '12px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            backgroundColor: '#F7F7F7'
                        }
                    }}
                >
                    <Box sx={{ flex: 1 }}>
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontWeight: 600,
                                color: '#242020'
                            }}
                        >
                            View Integration Documentation
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                color: '#828282'
                            }}
                        >
                            Detailed docs to help you set up your integration.
                        </Typography>
                    </Box>

                    <WhiteButtonWithIcon
                        text="View Docs"
                        icon={InsertDriveFileOutlinedIcon}
                        onClick={handleViewDocs}
                        sx={{
                            fontWeight: 700
                        }}
                        iconPosition="start"
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default NeedHelpContainer;